import { type Registry as Services, service } from '@ember/service';
import Component from '@glimmer/component';
import { t } from 'ember-intl';
import { and } from 'ember-truth-helpers';
import GeneralIconWithTooltip from 'lumen/components/general/icon-with-tooltip';

interface HotelAndMarketRevenueInsightFilterDisplayBarSignature {
  Args: {
    filterText: string;
    showTop200Info?: boolean;
  };
}

export default class HotelAndMarketRevenueInsightFilterDisplayBar extends Component<HotelAndMarketRevenueInsightFilterDisplayBarSignature> {
  @service declare intl: Services['intl'];
  @service declare riSelections: Services['ri-selections'];

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get tooltipText() {
    if (this.riSelections.isBudgetActive) {
      return this.intl.t(
        'revenue_insight.multi.breakdown-detail.top_200_detail.budget',
      );
    }
    if (this.riSelections.isForecastActive) {
      return this.intl.t(
        'revenue_insight.multi.breakdown-detail.top_200_detail.forecast',
      );
    }
    return this.intl.t(
      'revenue_insight.multi.breakdown-detail.top_200_detail.last_year',
    );
  }

  <template>
    <div
      class="segment-modal-content-header text-200--regular flex shrink-0 items-center justify-between"
    >
      <div class="truncate">
        {{@filterText}}
      </div>
      {{#if (and this.riSelections.isMultiProperty @showTop200Info)}}
        <div class="small-info-block">
          <div class="filter-display-bar__banner">
            <p
              class="filter-display-bar__content text-300--regular flex items-center gap-100"
            >
              <GeneralIconWithTooltip
                @side="top"
                @tooltipContent={{this.tooltipText}}
              />
              {{t "revenue_insight.multi.breakdown-detail.top_200_info"}}
            </p>
          </div>
        </div>
      {{/if}}
    </div>
  </template>
}
